import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import IndexNoteTool from "./notetool/IndexNoteTool.tsx";
import IndexNetCalendar from "./netcalendar/IndexNetCalendar.tsx";
import CalendarTable from "./netcalendar/components/CalendarTable.tsx";
import SchoolTimetable from "./netcalendar/components/SchoolTimetable.tsx";
import LignaProjectList from "./notetool/LignaProjectList.tsx";

const App = () => (
  <Router>
    <div className="App">
      <Routes>
        <Route path="/" element={<IndexNetCalendar />} />
        <Route path="/timetable" element={<SchoolTimetable />} />
        <Route path="/cal" element={<CalendarTable />} />
        <Route path="/lignanote" element={<IndexNoteTool />} />
        <Route path="/lignanote_projects" element={<LignaProjectList />} />
      </Routes>
    </div>
  </Router>
);

export default App;
